import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Input} from 'semantic-ui-react';

import searchClear from 'Assets/images/search-clear.svg';
import searchIcon from 'Assets/images/magnifying-class.svg';
import './searchInput.scss';

const SearchInput = ({onSearch, searchString, ...props}) => {
  const [value, setValue] = useState(searchString);

  useEffect(
    () => {
      setValue(searchString);
    },
    [searchString],
  );

  const handleSearchChange = (e, {value}) => setValue(value);

  const handleKeyUp = e => {
    if (e.keyCode === 13) {
      onSearch(value);
    }
  };

  if (!onSearch) return null;

  return (
    <Input
      className="search"
      onChange={handleSearchChange}
      onKeyUp={handleKeyUp}
      style={{marginBottom: 10}}
      value={value || ''}
      {...props}
    >
      <img
        className="search-icon icon"
        onClick={() => {
          onSearch(value);
        }}
        src={searchIcon}
      />
      <input />
      {value && (
        <img
          className="close icon"
          onClick={async () => {
            await setValue('');
            onSearch();
          }}
          src={searchClear}
        />
      )}
    </Input>
  );
};

SearchInput.propTypes = {
  searchString: PropTypes.string,

  //functions
  onSearch: PropTypes.func,
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/Common/Form/SearchInput.js